import React from 'react';
import { useSelector } from 'react-redux'

const Post = () => {
  const post = useSelector(state => state.cars.post);

  var edit = null;

  if ((post.href || "") != "") {
    if ((post.id || "") != "") {
      var edit_sub = null;

      if (post.slug.indexOf(post.slugDomain) != 0) {
        edit_sub = (
          <span>
            <span className="badge badge-danger">now using default</span>
            <span className="badge badge-secondary">source <strong>{post.slugDomain + "-" + post.slug}</strong></span>
            <a href="https://wp.gomme-auto.it/wp-admin/post-new.php" className="nolink" target="_blank">
              <span className="badge badge-danger">create</span>
            </a>
          </span>
        );
      }

      edit = (
        <span>
          <span className="badge badge-secondary">{post.slug}</span>
          <a href={post.href} className="nolink" target="_blank">
            <span className="badge badge-warning">edit</span>
          </a>
          {edit_sub}
        </span>
      );
    }
    else {
      edit = (
        <span>
          <span className="badge badge-secondary">{post.slug.indexOf(post.slugDomain) != 0 ? post.slugDomain + "-" + post.slug : post.slug}</span>
          <a href={post.href} className="nolink" target="_blank">
            <span className="badge badge-danger">create</span>
          </a>
        </span>
      );
    }
  }

  return (
    <div className="col-12">
      {edit}
      <div className="static-search-content wordpress" style={{ fontFamily: 'PT Sans Narrow', fontSize: "18px", color: "#454545" }}
           data-slug={post.slug} data-id={post.id} dangerouslySetInnerHTML={{ __html: post.body }}>
      </div>
    </div>
  );
};

export { Post };